import type { TowerDesign } from "@/game/towerSpec";
import type { Material } from "@/physics/model";
import { CATALOG } from "@/game/appurtenances";

/**
 * Croton-on-Hudson 140 ft monopole — real Nello pole at 1 Gateway Plaza, Croton
 * NY (M&B Tower / DISH), from reference_towers/02_engineering_drawings/
 * NY_CrotonOnHudson_monopole_140ft_structural.pdf (tnxTower SA).
 *   - Polygonal tapered tube, sleeve-REINFORCED (2021), 140 ft (42.67 m).
 *   - Base OD 53.4" (1.356 m), tip OD 18" (0.457 m); wall 0.1875"→0.4625".
 *   - TIA-222-H, Risk II, 114 mph, Exp C. Pole rating 85.6%. DISH at 85 ft;
 *     Sprint 140 / AT&T 130 / T-Mobile 120 / Verizon 110 / MTA 105 ft.
 * Grade not tabulated → A572-65 typical. Foundation page not read → competent pier.
 */
const A572_65: Material = { name: "A572 Gr65", E: 200e9, Fy: 448e6, rho: 7850 };
const AZ = [0, (2 * Math.PI) / 3, (4 * Math.PI) / 3];

export const design: TowerDesign = {
  id: "monopole-croton-140ft",
  name: "Monopole (Croton-on-Hudson 140 ft, Nello)",
  description: "Real reinforced 140 ft Nello monopole, Croton NY (M&B Tower / DISH).",
  author: "reference: NY Croton-on-Hudson 140 ft tnxTower SA",
  spec: {
    type: "monopole",
    height: 42.67,
    stack: {
      faces: 12, panels: 12,
      baseRadius: 0.68, topRadius: 0.23,
      legSection: "legXXL", braceSection: "braceHeavy",
      legMaterial: A572_65, braceMaterial: A572_65, bracing: "X",
    },
    shell: { baseDiameter: 1.356, topDiameter: 0.457 },
    foundation: {
      soil: "dense-sand",
      base: { type: "pier", width: 2.6, diameter: 2.6, depth: 7.0, concrete: "c30" },
      connection: {
        kind: "anchorBolts", nBolts: 12, bolt: "b1_75", grade: "f1554_105",
        boltCircleDia: 1.25, embedment: 0.45, edgeDistance: 0.3,
        platePlanArea: 1.8, plateThickness: 0.055, plateGrade: "a36rod", fc: 30e6,
      },
    },
    loads: [
      // five carriers stacked 105–140 ft (32–42.7 m)
      ...AZ.flatMap((azimuth) => [
        { appurtenance: CATALOG.panelSector, height: 42.7, azimuth },
        { appurtenance: CATALOG.panelSector, height: 39.6, azimuth },
        { appurtenance: CATALOG.panelSector, height: 36.6, azimuth },
        { appurtenance: CATALOG.panelSector, height: 33.5, azimuth },
        { appurtenance: CATALOG.rru, height: 42.7, azimuth },
        { appurtenance: CATALOG.rru, height: 36.6, azimuth },
      ]),
      { appurtenance: CATALOG.dish12, height: 25.9, azimuth: 0 }, // DISH at 85 ft
      { appurtenance: CATALOG.coaxBundle, height: 42.7, runLength: 42.7 },
      { appurtenance: CATALOG.coaxBundle, height: 42.7, runLength: 42.7 },
    ],
  },
};
